import { ICampModule } from '../model/camp-module.model';
import { ICamp } from '../model/camp.model';
import { TypeMossEnum } from '../constant/enum';

// A function used to get the Active survey Js modules excluding the ones that were converted to static
export function getActiveSurveyJSModules(camp: ICamp) {
  const modulesTypeMossToBeExclued: TypeMossEnum[] = [TypeMossEnum.INTERNATIONAL, TypeMossEnum.MARIN, TypeMossEnum.ACCUEIL_ETRANGER];
  let campModules: ICampModule[];
  if(camp && camp.campModules && camp.campModules.length > 0) {
    campModules = camp.campModules.filter((campModule: ICampModule) => campModule.actif == true && !modulesTypeMossToBeExclued.includes(campModule.module.typeMoss));
  }
  return campModules;
}
